<template>
  <div class="animated fadeIn card w-100">
    <div class="card-body view">
      <div class="header">
        <div class="title">
          <!--          <font-awesome-icon icon="trophy" size="4x"></font-awesome-icon>-->
          <div>Fragrance Attributes</div>
        </div>
        <div class="steps">
          <el-steps :active="1" finish-status="success">
            <el-step title="Step 1"></el-step>
            <el-step title="Step 2"></el-step>
            <el-step title="Step 3"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-wrapper__best-worst" :class="{overflow: selectedAttribute.length > 25}">
          <div style="display: flex;">
            <div :class="{'form-wrapper__best-worst__first-row': selectedAttribute.length > 25}">I want to see</div>
            <div :class="{'form-wrapper__best-worst__second-row': selectedAttribute.length > 25}">
              <el-radio-group v-model="localFormData.radioDesc" class="best-worst-switch">
                <el-radio-button value="best">best</el-radio-button>
                <el-radio-button value="worst">worst</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <span style="word-break: keep-all">"{{ selectedAttribute }}"*</span>
        </div>
        <div class="d-flex align-items-center">
          <span>Display the top</span>
          <el-input-number
            class="number-input"
            v-model="localSearchFilters.metrics.threshold.amount"
            :min="1"
            :step="1"
            :precision="0"
            controls-position="right"
          />
          <el-radio-group v-model="localFormData.radioPercentType" class="type-switch">
            <el-radio-button value="number">#</el-radio-button>
            <el-radio-button value="percentage">%</el-radio-button>
          </el-radio-group>
          <span>of fragrances</span>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end">
          <button class="btn next-button" @click="nextPage">Next</button>
        </div>
        <div class="footnote">
          <span>* based on <b>top 2 box</b> {{ selectedAttribute }} scores</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  emits: ['update:formData', 'update:searchFilters'],
  props: {
    'previousPage': Function,
    'nextPage': Function,
    'formData': Object,
    'selectedAttribute': String,
    'searchFilters': Object
  },
  name: 'TopWorstFirstForm',
  data () {
    return {
      localFormData: _.cloneDeep(this.formData),
      localSearchFilters: _.cloneDeep(this.searchFilters)
    }
  },
  watch: {
    formData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFormData)) {
          this.localFormData = _.cloneDeep(value)
        }
      }
    },
    localFormData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.formData)) {
          this.$emit('update:formData', _.cloneDeep(value))
        }
      }
    },
    searchFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localSearchFilters)) {
          this.localSearchFilters = _.cloneDeep(value)
        }
      }
    },
    localSearchFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.searchFilters)) {
          this.$emit('update:searchFilters', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.card {
  margin-bottom: 0;
  border: 0;
  width: 100%;
  background-color: transparent;
  max-width: 1300px;
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 3px 6px #000000;
  padding: 0;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 255, 255, 0.9) 70%,
    rgba(255, 255, 255, 0.6) 100%
  );

  .header {
    display: flex;
    justify-content: space-between;

    .steps {
      width: 270px;
      height: 62px;
      margin-top: 20px;
      margin-right: 29px;
    }
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 33px;
    @media screen and (min-width: $break-lg) {
      font-size: 20px;
      line-height: 38px;
    }
    @media screen and (min-width: $break-xl) {
      font-size: 24px;
      line-height: 43px;
    }
    @media screen and (min-width: $break-xxl) {
      font-size: 28px;
      line-height: 48px;
    }
    letter-spacing: 0;
    color: $dusty-blue;
    margin: 20px 0;
    @media screen and (min-width: $break-lg) {
      margin: 30px 0
    }
    @media screen and (min-width: $break-xl) {
      margin: 45px 0
    }
    @media screen and (min-width: $break-xxl) {
      margin: 60px 0
    }

    .first-form-row {
      margin-bottom: 30px;
    }

    .best-worst-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .type-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .number-input {
      margin-left: 20px;
      width: 98px !important;
      height: 43px !important;
      @media screen and (min-width: $break-lg) {
        height: 47px;
      }
      @media screen and (min-width: $break-xl) {
        height: 51px;
      }
      @media screen and (min-width: $break-xxl) {
        height: 55px;
      }
    }

    &__best-worst {
      margin-bottom: 25px;
      display: flex;
      &.overflow {
        flex-direction: column;
        align-items: center
      }
      &__first-row {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      &__second-row {
        margin: auto;
      }
    }
  }

  .next-button {
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background-color: $blueberry;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-right: 30px;
    margin-bottom: 15px;
    width: 160px;
    height: 38px;
    padding: 5px;
    @media screen and (min-width: $break-lg) {
      margin-right: 40px;
      margin-bottom: 20px;
      width: 180px;
      height: 40px;
      padding: 2px;
    }
    @media screen and (min-width: $break-xl) {
      margin-right: 60px;
      margin-bottom: 20px;
      width: 200px;
      height: 42px
    }
    @media screen and (min-width: $break-xxl) {
      margin-right: 80px;
      margin-bottom: 25px;
      width: 240px;
      height: 44px
    }
    transition: background-color 0.2s linear;
    &:hover {
      background-color: #9256D9;
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
  color: $pewter;
  text-transform: uppercase;
}

.footnote {
  height: 44px;
  background: transparent linear-gradient(268deg, #C961C5 0%, #DEBFDD 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  opacity: 0.9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (min-width: $break-lg) {
    height: 49px;
    span {
      font-size: 18px;
      line-height: 20px;
      margin-right: 50px;
    }
  }
  @media screen and (min-width: $break-xl) {
    height: 54px;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 55px;
    }
  }
  @media screen and (min-width: $break-xxl) {
    height: 59px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }

  span {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 18px;
    color: $charcoal;
    margin-right: 45px;
  }
}

</style>
<style lang="scss">
@import "../../assets/scss/variables";

.number-input {
  .el-input__inner {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0;
    color: $pewter;
    @media screen and (min-width: $break-lg) {
      height: 47px;
    }
    @media screen and (min-width: $break-xl) {
      height: 51px;
    }
    @media screen and (min-width: $break-xxl) {
      height: 55px;
    }
  }
}
</style>
